import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { Box, Tab, Tabs } from "@mui/material";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import { MyLeaveDashboard } from "my-leave/components";
import { useMyLeaveRoleTabs } from "my-leave/hooks";
import { OcPageNameTitle, OcPageTransition, OcTabPanel } from "oc/components";
import { useOcCurrentUserState } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";
import { ocSelectedTabState } from "states";

export const MyLeaveExaminerDashboardPage = () => {
  const { t } = useTranslation();
  const { contractCode } = useOcCurrentUserState();
  const isMobile = useOcIsMobile();
  const [selectedTab, setSelectedTab] = useRecoilState(
    ocSelectedTabState("leaveExaminerDashboard"),
  );

  const { data: rolesData } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  const { roles } = useMyLeaveRoleTabs({ rolesData });

  useEffect(() => {
    if (roles.length === 1) setSelectedTab(0);
  }, [roles.length, setSelectedTab]);

  return (
    <OcPageTransition>
      <Box>
        <OcPageNameTitle title={t("MY_LEAVE_EXAMINER_CONTROL_PANEL")} goBack={false} />
        <Box padding={isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px"}>
          <Box bgcolor="#E3E5E5">
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              onChange={(e, newValue) => setSelectedTab(newValue)}
              aria-label="tabs example"
            >
              {roles.map((role) => (
                <Tab key={role.key} id={role.key} label={role.label} />
              ))}
            </Tabs>
          </Box>
          {roles.map((role, index) => (
            <OcTabPanel key={role.key} value={selectedTab} index={index}>
              <MyLeaveDashboard role={role.key} />
            </OcTabPanel>
          ))}
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyLeaveExaminerDashboardPage;
